export default __webpack_public_path__ + "static/media/logo.fbef1ec3.png";